import { render, staticRenderFns } from "./MarketplacesHtml.vue?vue&type=template&id=670c0e2d"
import script from "./MarketplacesHtml.vue?vue&type=script&lang=js"
export * from "./MarketplacesHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports